import { Modal, Grid } from 'antd'
import ExportReportForm from './ExportReportForm'
import styles from '../../../../testrun.module.css'

const ExportReportModal = ({
    isOpen = false,
    setOpen = () => {},
    onExport = () => {},
    exporting = false,
    reportId = '',
}) => {
    const screens = Grid.useBreakpoint()
    const modalWidth = screens.lg ? 720 : screens.md ? 640 : '92%'

    return (
        <Modal
            open={isOpen}
            onCancel={() => setOpen(false)}
            destroyOnClose
            width={modalWidth}
            footer={null}
            centered
            title="Export Report"
            maskClosable={!exporting}
            closable={!exporting}
            className="test-run-modal"
        >
            <div className={styles.exportFormWrap}>
                <ExportReportForm
                    onExport={onExport}
                    exporting={exporting}
                    setOpen={setOpen}
                    reportId={reportId}
                />
            </div>
        </Modal>
    )
}

export default ExportReportModal
